import React from "react";

import { getTranslation } from "../../helpers/getLanguage";
import ViewTutorialButtonWithModal from "../common/ViewTutorialButtonWithModal";
import CustomSearchInput from "../inputs/CustomSearchInput";
import CustomToggle from "../inputs/CustomToggle";

const SubtractionHeader = ({ inputValues, handleChange, isSorted, setSorted, sortLabel, productType }) => {
  return (
    <div className="multiplication-header-container width-100">
      <div className="flex-column multiplication-header-container-tutorial">
        <div style={{ flexGrow: 1, marginBottom: "10px" }}>
          <ViewTutorialButtonWithModal name="Multiplication" />
        </div>
        <span className="components-dashboard-title">
          {getTranslation(productType === "process" ? "PAGE_MULTIPLICATION_TITLE_STEPS" : "PAGE_MULTIPLICATION_TITLE")}
        </span>
      </div>

      <div className="flex multiplication-header-container-settings">
        <CustomSearchInput
          name="search"
          placeholder={getTranslation(
            productType === "process" ? "PAGE_STEPS_SEARCH_COMPONENTS" : "PAGE_COMPONENT_SEARCH_COMPONENTS",
          )}
          value={inputValues.search}
          onChange={handleChange}
          containerClass="search-input-container-subtraction-components mb-10"
        />

        <div className="toggle-container flex align-center">
          <CustomToggle
            value={isSorted}
            setValue={(e) => setSorted(e)}
            label={sortLabel}
            labelClass="custom-toggle-label-default sort-toggle"
            left
          />
        </div>
      </div>
    </div>
  );
};

export default SubtractionHeader;
